const formValues = {
    user_nome: '',
    user_email: '',
    user_telefone : '',
    mensagem: '',
    itens: ''
}

export default formValues;